import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import PropertyDetailImages from 'lib/PropertyDetailImages';
import {findReportTypeSection} from 'ducks/reportSections';
import {isEnabled} from 'api/reports/util/SectionUtils';

export const makeTargetPropertySection = (s) => {
  const sectionData = s.sectionData.toggleProfileBlurb ?
      {
        ...s.sectionData
      } :
      {
        ...s.sectionData,
        toggleProfileBlurb: get(s, 'sectionData.toggleProfileBlurb', true),
      };

  return {
    name: s.key,
    title: get(s, 'sectionData.title'),
    pdf: s.url,
    data: isEmpty(sectionData) ? undefined : sectionData,
  };
};
export const makeTargetProperty = (reportSections, propertyDetail) => {
  const targetProperty = {
    ...propertyDetail,
    selectedImages: PropertyDetailImages.reportSummaryPhotos(propertyDetail),
    targetPhotoList: PropertyDetailImages.targetPropertyPhotoList(propertyDetail),
  };
  const coverSection = findReportTypeSection(reportSections, 'COVER_PAGE');
  if (isEnabled(coverSection, 'singleLineAddress') && get(coverSection, 'sectionData.singleLineAddress')) {
    targetProperty.singleLineAddress = coverSection.sectionData.singleLineAddress;
  }
  return targetProperty;
};